export default __webpack_public_path__ + "media/avatars/03-f65ad033.png";